
















































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import CreatePublicHolidayRequest from '@/models/Settings/Regions/CreatePublicHolidayRequest';

@Component({ name: 'PublicHolidayCreate' })
export default class extends SaascadaVueDialog {

    request: CreatePublicHolidayRequest = new CreatePublicHolidayRequest();
    holidayDateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreatePublicHolidayRequest();
            this.request.regionId = RegionsModule.region.id;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // The date picker only saves date so we need to convert to date-time format
            this.request.holidayDate = new Date(this.holidayDateAsString);

            await RegionsModule.createPublicHoliday(this.request);
        }
    }

}
